/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import mapKeys from 'lodash/mapKeys'

import { InputText } from 'primereact/inputtext';
import {Checkbox} from 'primereact/checkbox';
import { TabMenu } from 'primereact/tabmenu';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Menu } from 'primereact/menu';

import Header from '@components/Header';
import JustificationModal from '@components/JustificationModal';
import AddTextModal from '@components/Traslate/AddTextModal';

import { getDictionaryProcess, updatetextDictionaryProcess, deleteTextProcessDictionary, addTextProcessDictionary } from '@actions/locale';
import { sendActionToBitacora  } from '@actions/bitacora';


import './style.scss'

class Dictionary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      path: '',
      dictionary: {},
      fullDictionary: {},
      onlyMissingValues: false,
      find: '',
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      showModalAddText: {
        isVisible: false
      }
    };

    this.items = [
      {
        label: this.props.t('Nuevos textos al Diccionario Procesos'),
        icon: 'pi pi-cog',
        command: () => {
          this.openModalAddNewTextProcess()
        }
    },
    ]
  }

  async componentDidMount () {
    const { history } = this.props
    if (!history.location.state?.path) return history.push('/process-dictionary')
    if (history.location.state?.textSearch) this.setState({'find': history.location.state?.textSearch})
    this.setState({
      path: history.location.state?.path
    }, () => {
      this.onChangeTab({index: 0})
    })
  }

  getDictionaryProcessByLanguage = async (language) => {
    const { getDictionaryProcess } = this.props
    const { path } = this.state
    const response = await getDictionaryProcess(path, language)
    if (!response?.status) {
      this.setState({
        fullDictionary: response.data,
        dictionary: response.data
      })
    }
  }

  onUpdateTextDictionary = async ({target}) => {
    const { updatetextDictionaryProcess, keysLenguages, sendActionToBitacora } = this.props
    const { path, activeTabIndex } = this.state
    const prefixLenguage = keysLenguages[activeTabIndex];

    const data = {
      path,
      key: target.name,
      value: this.validateValueDictionary(target.value.trim()),
      clave: prefixLenguage
    }
    await updatetextDictionaryProcess(data)
    const dataBitacora = {
      transactionName: 'actDicProcesos',
      reason: `${target.name} - ${prefixLenguage} || ${data.value}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

  validateValueDictionary = (value) => {
    const formatValue = value.replace(/"/g, "“")
    return formatValue
  }

  onChangeObj = ({target}) => {
    const { dictionary, fullDictionary } = this.state
    const value = target.value.replace(/^\s+/g, '')
    dictionary[target.name] = value
    fullDictionary[target.name] = value
    this.setState({dictionary, fullDictionary})
  }

  onChangeFind = ({target}) => {
    this.setState({[target.name]: target.value}, () => this.filterDirectory())
  }

  filterDirectory = () => {
    const { fullDictionary, onlyMissingValues, find } = this.state
    let filterDictionary = {}
    if (onlyMissingValues) {
      mapKeys(fullDictionary, (value, key) => {
        if(!value) filterDictionary[key] = value
      })
    } else filterDictionary = fullDictionary
    if (find) {
      filterDictionary = Object.keys(filterDictionary).reduce((accum, key) => {
        if ((key.toUpperCase()).includes(find.toUpperCase())) accum[key] = filterDictionary[key]
        else if ((filterDictionary[key].toUpperCase()).includes(find.toUpperCase())) accum[key] = filterDictionary[key]
        return accum;
      }, {})
    }
    this.setState({dictionary: filterDictionary})
  }

  onChangeTab = async (e) => {
    const { keysLenguages } = this.props
    const { find } = this.state
    this.setState({ 
      activeTabIndex: e.index,
      dictionary: {},
      fullDictionary: {},
      onlyMissingValues: false
     })
    const prefixLenguage = keysLenguages[e.index];

    await this.getDictionaryProcessByLanguage(prefixLenguage)
    if (find) this.filterDirectory()
  }

  onConfirmDeleteText = (key) => {
    const { dictionary } = this.state
    const { t } = this.props;
    const data = [ key ]
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: dictionary[key] || key}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteText(data, justification),
      }
    });
  }

  onDeleteText = async (data, justification) => {
    const { t, deleteTextProcessDictionary, sendActionToBitacora, keysLenguages } = this.props;
    const { path, find, activeTabIndex } = this.state
    const body = {
      data,
      path
    }
    const response = await deleteTextProcessDictionary(body);
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'bajaDicProcesos',
        reason: `${data[0]} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      const prefixLenguage = keysLenguages[activeTabIndex];

      await this.getDictionaryProcessByLanguage(prefixLenguage)
      if (find) this.filterDirectory()

      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
  };

  openModalAddNewTextProcess = () => {
    return this.setState({
      showModalAddText: {
        isVisible: true
      }
    })
  }

  onAddNewTexProcess = async ({justification, newTexts}) => {
    const { addTextProcessDictionary, sendActionToBitacora, keysLenguages} = this.props
    const { path, activeTabIndex, find } = this.state
    const formatText = newTexts.reduce((obj, item) => {
      obj[item] = item
      return obj
    }, {})

    const response = await addTextProcessDictionary({path, newTextObj: formatText})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'altaDicProcesos',
        reason: `${newTexts} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      const prefixLenguage = keysLenguages[activeTabIndex];

      await this.getDictionaryProcessByLanguage(prefixLenguage)
      if (find) this.filterDirectory()
    }

  }

  render() {
    const { t, itemsTabsLenguages, keysLenguages, isFullAdmin } = this.props;
    const { path, activeTabIndex, dictionary, onlyMissingValues, find, showModalJustification, showModalAddText } = this.state;

    const renderTranslations = Object.keys(dictionary).map((key, index) => (
      <>
        <div className={`p-col-12 border-bottom-lg-blue ${isFullAdmin ? "p-lg-5 p-md-5" : "p-lg-6 p-md-6" } `} keys={index}>
          <label className="p-text-bold">{key}</label>
        </div>
        <div className="p-col-12 p-lg-6 p-md-6 border-bottom-blue">
          <InputText
            name={`${key}`}
            value={dictionary[key]}
            onChange={this.onChangeObj}
            className="is-full-width"
            onBlur={this.onUpdateTextDictionary}
          />
        </div>
        { isFullAdmin && (
          <div className='p-col-12 p-lg-1 p-md-1 p-text-center border-bottom-blue'>
            <Button
              type="button"
              icon="pi pi-trash"
              className="p-button-text"
              style={{ marginRight: '.5em' }}
              onClick={() => this.onConfirmDeleteText(key)}
            />
          </div>
        )}
      </>
    ))


    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <div className='p-grid p-p-4'>
          <div className="p-col-12 p-md-8 p-lg-8 p-d-flex p-ai-center  background-light-gray ">
            <div className="p-col p-d-flex p-ai-center is-full-width">
              <label className="p-mr-2 p-text-bold">{t('Texto', {lng: prefixLenguage })}</label>
              <InputText
                name="find"
                value={find}
                onChange={this.onChangeFind}
                className="p-mr-2 input-search-list is-full-width"
              />
            </div>
          </div>
          <div className="p-col-12 p-md-4 p-lg-4 l p-d-flex p-ai-center is-full-width background-light-gray ">
            <Checkbox inputId="cb1" checked={onlyMissingValues} onChange={e => this.setState({ onlyMissingValues: e.checked }, () => this.filterDirectory())} />
            <label htmlFor="cb1" className="p-checkbox-label p-pl-2">{t('Ver solo faltantes', {lng: prefixLenguage })}</label>
          </div>
          <div className="p-col-6 border-header-blue p-p-3">
            <label className="p-text-bold">{t('Texto')}</label>
          </div>
          <div className="p-col-6 border-header-blue p-p-3">
            <label className="p-text-bold">{t('Traducción', {lng: prefixLenguage })}</label>
          </div>
          { renderTranslations}
        </div>
      )}

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={`${t('Diccionario de ')} "${path}"`} linkText={t("Ir al listado")} to="/process-dictionary"/>
        </div>

        <div className="p-col-12 p-card ">
          { isFullAdmin && (
            <div className='p-col-12 p-d-flex p-jc-end'>
              <Menu model={this.items} popup ref={el => this.menu = el} id="popup_menu" />
              <Button
                // label="Show"
                className='p-button-secondary p-button-outlined'
                icon="pi pi-ellipsis-v"
                onClick={(event) => this.menu.toggle(event)}
                aria-controls="popup_menu"
                aria-haspopup
              />
            </div>
          )}
          <div className="p-col-12">
            {itemsTabsLenguages && (
              <TabMenu
                model={itemsTabsLenguages}
                activeIndex={activeTabIndex}
                onTabChange={this.onChangeTab}
              />
            )}
          </div>
          {renderByTabLenguage()}
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: {isVisible: false}})}
          onContinueAction={showModalJustification.continueAction}
        />
        { showModalAddText.isVisible && (
          <AddTextModal
            // display={showModalAddText.isVisible}
            onHidden={() => this.setState({showModalAddText: {visible: false}})}
            onContinueAction={this.onAddNewTexProcess}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  isFullAdmin: state.settings.isFullAdmin,
});

const mapDispatchToProps = {
  getDictionaryProcess,
  updatetextDictionaryProcess,
  sendActionToBitacora,
  deleteTextProcessDictionary,
  addTextProcessDictionary
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Dictionary);
